export default function JsonLD({ data }: { data: unknown }) {
  // Remove undefined to avoid "undefined" strings in JSON
  const json = JSON.stringify(data, (_, v) => (v === undefined ? null : v));
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
}
